import { all } from "redux-saga/effects"

// All invoice operations are handled synchronously via reducer (mock data, no API calls).
export default function* aiInvoiceSaga() {
  yield all([])
}
